// Screen shown on app start, while content availability is being fetched.

<template>

	<div class="well">
		<h1>Loading...</h1>
	</div>

</template>

<style scoped>

.well {
	width: 50%;
	margin: auto;
}

</style>